
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 9 9","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M4.898.165a.563.563 0 00-.796.795L7.08 3.938H.563a.563.563 0 000 1.124H7.08L4.102 8.04a.563.563 0 00.796.795l3.937-3.937a.563.563 0 000-.796z","fill":"#fff","fill-rule":"evenodd"}})])
          )
        }
      }
    